import { DeleteIconCircle } from "assets/icons";
import ActionModal from "components/Settings/components/ActionModal";
import "./style.scss";
import OtpInput from "components/BaseWidgets/form/otp";
import Button from "components/BaseWidgets/button";
import { useEffect, useState } from "react";
import { useVerifyOtp } from "hooks/api/useSettings";

function OtpModal({ open, setOpen, identifier, deletePayload, onDelete }) {
  const timerCount = 15;
  const [resendTimer, setResendTimer] = useState(timerCount);
  const [canResend, setCanResend] = useState(false);
  const [otp, setOtp] = useState("");

  const { mutate: otpSubmit, isLoading } = useVerifyOtp({
    onSuccess: () => {
      onDelete(deletePayload);
      setOpen(false);
    },
  });

  const handleSubmit = () => {
    otpSubmit({ identifier, otp });
  };

  useEffect(() => {
    let timer;

    if (resendTimer > 0 && open) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }

    if (resendTimer === 0) {
      setCanResend(true);
    }

    return () => clearInterval(timer);
  }, [resendTimer, open]);

  useEffect(() => {
    if (open) {
      setResendTimer(timerCount);
      setCanResend(false);
      setOtp("");
    }
  }, [open]);

  const handleResend = () => {
    if (!canResend) return;
    setResendTimer(timerCount);
    setCanResend(false);
  };

  return (
    <ActionModal
      title="Delete your account?"
      open={open}
      setOpen={setOpen}
      footer={{
        right: { label: "Submit", action: handleSubmit, loading: isLoading },
      }}
      icon={<DeleteIconCircle />}
    >
      <div className="flex flex-col items-center mt-5 settings-otp-modal">
        <div className="flex items-center gap-3 mb-8">
          <p className="number-text">
            Enter OTP sent to <span className="ml-1">{identifier}</span>
          </p>
          <Button variant="link" className="change-btn" height={22}>
            Change
          </Button>
        </div>

        <OtpInput value={otp} onChange={setOtp} wrapperClass="items-center" />

        <div className="mt-4 flex items-center gap-3">
          <p className="number-text">Haven’t received your code?</p>
          {!canResend ? (
            <span className="resend-timer">
              Resend in 00:{resendTimer.toString().padStart(2, "0")}
            </span>
          ) : (
            <Button
              onClick={handleResend}
              className="resend-btn"
              variant="link"
              height={22}
            >
              Resend
            </Button>
          )}
        </div>
      </div>
    </ActionModal>
  );
}

export default OtpModal;
